import { Actions } from './types';

/**
 * Compares two arrays to find which items were:
 * added (ie. in updated list but not original list) and
 * removed (ie. items not in updated list but are in original list)
 */
export const getChangedIds = (currentList: number[], updatedList: number[]) => {
  const uniqueIds = Array.from(new Set([...currentList, ...updatedList]));
  const changes: { [key: string]: number[] } = {
    added: [],
    removed: [],
  };

  return uniqueIds.reduce((acc, current) => {
    const isInCurrent = currentList.includes(current);
    const isInUpdated = updatedList.includes(current);

    if (isInCurrent && !isInUpdated) {
      acc.removed.push(current);
    }

    if (!isInCurrent && isInUpdated) {
      acc.added.push(current);
    }

    // if in both, just return accumulator without any updates
    return acc;
  }, changes);
};

/**
 * Determine number of items added and removed for each row
 */
export const formatRow = (current: number[], updated: number[]) => {
  const { added, removed } = getChangedIds(current, updated);
  return {
    added: added.length,
    removed: removed.length,
    total: updated.length,
  };
};

/**
 * Determine if the flag is being enabled globally,
 * was previously enabled globally and is being disabled,
 * or if just individual changes.
 */
export const formatAction = (prevEnabled: boolean, currEnabled: boolean) => {
  if (currEnabled) return Actions.Enabled;
  if (prevEnabled && !currEnabled) return Actions.Disabled;
  return undefined;
};
